module.exports = __webpack_public_path__ + "static/media/Colette Single Bed Base - 120x200 cm_Blush Pink.82f2eba9.png";